import { Moment } from 'moment-timezone'
import React from 'react'
import { translateNode } from 'src/localization/translateNode'

export const momentIsEmpty =
  (message?: string) =>
  (val?: Moment): React.ReactElement | undefined =>
    val === undefined
      ? translateNode(message !== undefined ? message : 'Must not be blank')
      : undefined
